import React, { SVGProps } from 'react';

export const BackupIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor">
      <path d="M1.8 9.96c0-8.162 1.282-8.7 10.2-8.7s10.2.538 10.2 8.7c0 5.456-.573 7.505-3.617 8.265l1.217 3.989-1.722.525-1.29-4.227c-1.28.123-2.854.148-4.788.148s-3.508-.025-4.789-.148l-1.29 4.227-1.721-.525 1.217-3.99C2.373 17.466 1.8 15.417 1.8 9.96m2.884-6.008c-.29.233-.579.633-.785 1.586C3.683 6.534 3.6 7.93 3.6 9.96s.083 3.427.299 4.422c.206.954.495 1.353.785 1.586.336.27.942.534 2.191.695 1.243.161 2.884.197 5.125.197s3.882-.036 5.125-.197c1.25-.161 1.855-.424 2.191-.695.29-.233.579-.632.785-1.586.216-.995.299-2.392.299-4.422s-.083-3.426-.299-4.422c-.206-.953-.495-1.353-.785-1.586-.336-.27-.942-.533-2.191-.695-1.243-.161-2.884-.197-5.125-.197s-3.882.036-5.125.197c-1.25.162-1.855.424-2.19.695" />
      <path d="m10.841 6.499 4.74 2.737a.837.837 0 0 1 0 1.45l-4.74 2.737a.837.837 0 0 1-1.256-.726V7.224a.837.837 0 0 1 1.256-.725" />
    </g>
  </svg>
);
